export const getLoadingFilterOptions = (
  selectedOptions: string[] = [],
  isLoading: boolean
) => new Set(isLoading ? selectedOptions : []);

// MUI Checkbox uses 9px of padding around its 24px icon by default (42px total).
// The spinner is centered inside the same external area to keep labels fixed.
export const selectionIndicatorSlotSx = {
  width: 42,
  minWidth: 42,
  height: 42,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
};
